
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Use createRoot API with a two-phase mounting strategy
const container = document.getElementById("root");

if (container) {
  const root = createRoot(container);
  
  // Add priority hints for critical resources
  if ('loading' in HTMLImageElement.prototype) {
    const images = document.querySelectorAll('img[loading="lazy"]');
    images.forEach(img => {
      const imgElement = img as HTMLImageElement;
      if (imgElement.dataset && imgElement.dataset.critical) {
        imgElement.loading = 'eager';
      }
    });
  }
  
  // Prioritize initial render
  root.render(<App />);
  
  // Register performance observer to track key metrics
  if ('PerformanceObserver' in window) {
    try {
      // Monitor LCP (Largest Contentful Paint)
      const lcpObserver = new PerformanceObserver((entryList) => {
        const entries = entryList.getEntries();
        const lastEntry = entries[entries.length - 1];
        console.log('LCP:', lastEntry.startTime / 1000, 'seconds');
      });
      
      lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
      
      // Monitor FID (First Input Delay)
      const fidObserver = new PerformanceObserver((entryList) => {
        const entries = entryList.getEntries();
        const firstEntry = entries[0];
        // Use type assertion to access processingStart property on PerformanceEventTiming
        const firstInputEntry = firstEntry as PerformanceEventTiming;
        console.log('FID:', firstInputEntry.processingStart - firstInputEntry.startTime, 'ms');
      });
      
      fidObserver.observe({ type: 'first-input', buffered: true });
      
      // Add CLS monitoring
      const clsObserver = new PerformanceObserver((entryList) => {
        const entries = entryList.getEntries();
        let clsValue = 0;
        entries.forEach(entry => {
          // Access value property on LayoutShift entry
          const layoutShift = entry as LayoutShift;
          if (!layoutShift.hadRecentInput) {
            clsValue += layoutShift.value;
          }
        });
        console.log('CLS:', clsValue);
      });
      
      clsObserver.observe({ type: 'layout-shift', buffered: true });
    } catch (e) {
      console.log('PerformanceObserver error:', e);
    }
  }
}
